import { z } from 'zod';
import { AddressInput } from '@anytag/graphql';
import { getSchemaForType } from '@anytag/shared-types';

export const AddressInformationSchema = z.object({
  addressInformation: getSchemaForType<AddressInput>()(
    z.object({
      city: z.string(),
      address: z.string(),
      address2: z.string(),
      fullName: z.string(),
      furigana: z.string().nullish(),
      province: z.string(),
      postalCode: z.string()
    })
  ).nullable()
});

export type AddressInformationFormValues = z.infer<typeof AddressInformationSchema>;
